import script from "./ConnectionsList.vue?vue&type=script&setup=true&lang=js"
export * from "./ConnectionsList.vue?vue&type=script&setup=true&lang=js"

import "./ConnectionsList.vue?vue&type=style&index=0&id=27206e39&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27206e39"]])

export default __exports__